import userAuth from '@Config/userauth';
import { APPCONFIG } from '@/app.config';
import { apiFetch } from '@Shared/Api/apiClient';

export const SIMULATION_PERMISSIONS_CHANGED = 'simulation-permissions-changed';
let lastRefreshId = 0;

// Vuelve a validar los permisos del usuario autenticado y el ámbito de datos seleccionado
export async function refreshSimulationPermissions() {
  if (!userAuth.hasCurrentSession()) { userAuth.cleanSimulator(); return false; }
  if (!userAuth.isSimulating()) return true;
  const refreshId = ++lastRefreshId;
  const storage = userAuth.getStorage();
  const contextId = storage.getItem('simulationContextId');
  const token = storage.getItem('access_token');
  const target = userAuth.userIdProducer();
  const current = () => refreshId === lastRefreshId && contextId === userAuth.getStorage().getItem('simulationContextId') && token === userAuth.getStorage().getItem('access_token') && target === userAuth.userIdProducer();
  let permissions = [];
  try {
    const params = new URLSearchParams({ userIdProducer: target, userId: userAuth.simulatorUserId() });
    const response = await apiFetch(`${APPCONFIG.ENDPOINTS.PRODUCERURL}api/simulator/getpermissionsproducersimulator?${params}`);
    if (!response.ok) throw new Error('No se pudo validar la simulación.');
    const data = await response.json();
    if (!Array.isArray(data) || data.some(permission => typeof permission !== 'string')) throw new Error('Permisos inválidos.');
    permissions = [...new Set(data)];
  } catch {
    // A rejected/expired scope must not keep permissions from the selection response.
  }
  if (!current()) return false;
  const serialized = JSON.stringify(permissions);
  if (storage.getItem('simulatedPermissions') !== serialized) {
    storage.setItem('simulatedPermissions', serialized);
    window.dispatchEvent(new Event(SIMULATION_PERMISSIONS_CHANGED));
  }
  return true;
}
